import React, { Component } from 'react';

export default class CashJournalForm extends Component {

}
